import { render, staticRenderFns } from "./StandardComponent.vue?vue&type=template&id=046a9528&scoped=true&"
import script from "./StandardComponent.vue?vue&type=script&lang=js&"
export * from "./StandardComponent.vue?vue&type=script&lang=js&"
import style0 from "./StandardComponent.vue?vue&type=style&index=0&id=046a9528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046a9528",
  null
  
)

export default component.exports